import { AbstractControl, AsyncValidatorFn } from "@angular/forms";
import { map } from "rxjs";
import { SlotService } from "src/app/cabinet/services/slot.service.";
import { IBaseGetByCabinetRequest } from "src/app/core/models/base";

export function SlotValidator(slotService: SlotService, id: string): AsyncValidatorFn {
    return  (control: AbstractControl) => {
        const request : IBaseGetByCabinetRequest= {
            pageNumber:0,
            pageSize: 999999,
            cabinetId: id,
            advancedFilter:{
                logic: "and",
                filters: [
                    {
                        field: 'name',
                        operator: 'eq',
                        value: control.value
                    }
                ]
            }
        }

        return slotService.getSlotsByCabinet(request)
        .pipe(
            map(response => {
                const slots = response.data;

                return slots.length != 0 ? {nameIsNotUnique: true} : null;    
            })
        )
    }
}
